var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReFetch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90.000000pt",
    height: "90.000000pt",
    viewBox: "0 0 90.000000 90.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,90.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355 797 c-52 -18 -122 -54 -130 -68 -5 -7 -20 1 -41 22 l-34 33 0 -92 0 -92 92 0 92 0 -39 40 c-33 34 -37 43 -25 51 90 63 216 73 312 26 94 -46 149 -126 166 -238 7 -49 10 -54 32 -54 24 0 25 3 24 55 -2 118 -89 242 -208 296 -71 32 -178 41 -241 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 466 c-10 -26 4 -48 28 -44 33 4 33 52 0 56 -13 2 -25 -3 -28 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 326 c0 -13 6 -26 13 -29 22 -7 37 4 37 29 0 19 -5 24 -25 24 -20 0 -25 -5 -25 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 327 c0 -27 19 -40 39 -27 20 12 8 45 -17 48 -18 3 -22 -1 -22 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201 240 c-18 -11 -9 -44 13 -48 21 -4 37 14 29 34 -6 17 -27 24 -42 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 234 c-20 -20 -9 -46 18 -42 25 4 34 43 12 51 -9 4 -22 -1 -30 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 157 c-8 -21 8 -39 29 -35 11 2 20 13 22 26 3 18 -1 22 -21 22 -14 0 -27 -6 -30 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 148 c3 -25 36 -37 48 -17 13 20 0 39 -27 39 -20 0 -24 -4 -21 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 136 c-10 -26 4 -48 28 -44 33 4 33 52 0 56 -13 2 -25 -3 -28 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReFetch);
export default __webpack_public_path__ + "static/media/re-fetch.f0029e66024a826dbc8f4e67e5a35d5a.svg";
export { ForwardRef as ReactComponent };